<template>
    <div class="offer-slot">
        <div class="offer-slot__title">{{ title }}</div>
        <div class="offer-slot__description">{{ description }}</div>

        <div class="offer-slot__details">
            <div class="offer-slot__rules">
                <div v-if="offer.isEveryDay()" class="rules-day">
                    <span>{{ $t('offers_stage.every_day') }}</span>
                </div>
                <div v-else-if="offer.isWeekends()" class="rules-day">
                    <span>{{ $t('offers_stage.weekends') }}</span>
                </div>
                <div v-else-if="offer.isWeekdays()" class="rules-day">
                    <span>{{ $t('offers_stage.weekdays') }}</span>
                </div>
                <div v-for="rule in rules" class="rules-day" v-else>
                    <span>{{ rule.day }}s</span>
                    <!-- <span class="rules-times" v-if="rule.from || rule.to">{{ rule.from }} - {{ rule.to }}</span> -->
                </div>
                
            </div>

            <div class="offer-slot__people-requirement" v-if="minPax || maxPax">
                <div>
                    <svg width="12" height="12" viewBox="0 0 1792 1792"><path d="M1536 1399q0 109-62.5 187t-150.5 78h-854q-88 0-150.5-78t-62.5-187q0-85 8.5-160.5t31.5-152 58.5-131 94-89 134.5-34.5q131 128 313 128t313-128q76 0 134.5 34.5t94 89 58.5 131 31.5 152 8.5 160.5zm-256-887q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"/></svg>
                </div>

                <div v-if="minPax">
                    {{ $t('offers_stage.min') }} <span>{{minPax}}</span>
                </div>
                <div v-if="maxPax">
                    {{ $t('offers_stage.max') }} <span>{{maxPax}}</span>
                </div>
            </div>
            

            <div class="offer-slot__validity" v-if="validFrom || validTo">
                <div v-if="validFrom && offer.shouldShowValidFrom">
                    <em>{{ $t('offers_stage.valid_from') }}</em> {{ validFrom }}
                </div>
                <div v-if="validTo">
                    <em>{{ $t('offers_stage.valid_to') }}</em> {{ validTo }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'offerSlot',
  props: [
    'title',
    'description',
    'validFrom',
    'validTo',
    'rules',
    'minPax',
    'maxPax',
    'offer'
  ]
}
</script>



// WEBPACK FOOTER //
// offerSlot.vue?4a29a0f6